"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDocuments = getAllDocuments;
exports.searchDocuments = searchDocuments;
exports.getMyDocuments = getMyDocuments;
exports.getSummary = getSummary;
exports.getSharedSummary = getSharedSummary;
exports.getShareLink = getShareLink;
exports.getNotes = getNotes;
exports.getFirstNote = getFirstNote;
exports.createNote = createNote;
exports.createTemplate = createTemplate;
exports.updateNote = updateNote;
exports.deleteNote = deleteNote;
exports.createSummary = createSummary;
exports.createSummaryFromText = createSummaryFromText;
exports.attachFiles = attachFiles;
exports.followUp = followUp;
exports.transcriptYoutubeVideo = transcriptYoutubeVideo;
exports.scrapURL = scrapURL;
exports.editDocumentTitle = editDocumentTitle;
exports.deleteDocument = deleteDocument;
exports.regenerateImage = regenerateImage;
exports.uploadImage = uploadImage;
exports.getDocumentImages = getDocumentImages;
exports.generateFiveMinutesAudio = generateFiveMinutesAudio;
exports.podcastfy = podcastfy;
exports.getUrlFromBrave = getUrlFromBrave;
const axios_1 = require("axios");
const streaming_1 = require("./streaming");
const interceptorsCached_1 = require("./interceptorsCached");
const interceptorsAnonAuth_1 = require("./interceptorsAnonAuth");
const document_1 = require("../helper/document");
const application_host_1 = require("../common/application-host");
const apis_1 = require("../common/apis");
const error_1 = require("../common/error");
const axios_2 = __importDefault(require("axios"));
const EXISTENT_SHARED_DOCUMENT_MESSAGE = 'Shared document already exists!';
const DOCUMENT_PAYLOAD = {
    attitude: "",
    background: "Expert in analysing documents.",
    characterName: "Document Doctor",
    description: "",
    generationId: "",
};
const TEXT_PAYLOAD = {
    attitude: "",
    background: "Expert in analyzing documents.",
    characterName: "Document Doctor",
    description: "",
    generationid: "",
    youtubeUrl: "",
    webUrl: "",
    language: "",
};
function getAllDocuments() {
    return (interceptorsAnonAuth_1.networkCall
        .get(`${apis_1.APP_CONSTANTS.documents.share}?userId=${application_host_1.SUMMARAIZER_ADMIN}&limit=100`).then((response) => (!response.success || response.error
        ? new error_1.APIError(response.error?.message)
        : response.data)).catch((error) => new error_1.RequestError(error)));
}
;
function searchDocuments(query) {
    return (interceptorsCached_1.cachedAuthCall
        .get(`${apis_1.APP_CONSTANTS.documents.search(query)}`).then((response) => (!response.success || response.error
        ? new error_1.APIError(response.error?.message)
        : response.data)).catch((error) => new error_1.RequestError(error)));
}
;
function getMyDocuments() {
    return interceptorsCached_1.cachedAuthCall.get(`${apis_1.APP_CONSTANTS.documents.index}?sort=DESC`).then((response) => response.data).catch((error) => {
        if (error.code === 'ERR_CANCELED') {
            return null;
        }
        ;
        return new error_1.RequestError(error, {
            reason: error.response?.status === axios_1.HttpStatusCode.Unauthorized ? 'Session Out' : undefined,
        });
    });
}
;
function getSummary(conversationId) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.summaryJson, { conversationId }).then((response) => {
        if (response.success) {
        }
        else {
            switch (response.error?.message) {
                case 'Error while getting the JSON from S3 database. Error: NoSuchKey: The specified key does not exist.':
                    return new error_1.APIError(response.error.message, { reason: 'Not Found', module: 'Summary' });
                default:
                    return new error_1.APIError(response.error?.message, { module: 'Summary' });
            }
        }
        return response.success
            ? response.data
            : new error_1.APIError(response.error?.message, { module: 'Summary' });
    }).catch((error) => new error_1.RequestError(error, { module: 'Summary' }));
}
;
function getSharedSummary(shareId, password) {
    return interceptorsCached_1.cachedAuthCall.post(`${apis_1.APP_CONSTANTS.documents.shareDetails}`, { shareId, ...(password && { password }) }).then((response) => (response.success ? response.data : new error_1.APIError(response.error?.message, { module: 'Summary' }))).catch((error) => new error_1.RequestError(error, { module: 'Summary' }));
}
;
function getShareLink(conversationId, fileIds, password) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.share, {
        conversationId,
        fileIds,
        ...(typeof password === 'string' && { password }),
        ...(typeof password === 'boolean' && { resetPassword: password }),
    }).then((response) => (response.success || response.error?.message === 'SharedId already exists'
        ? response.data
        : new error_1.APIError(response.error?.message))).catch((error) => new error_1.RequestError(error));
}
;
//Notes
function getNotes(characterId) {
    return interceptorsCached_1.cachedAuthCall.get(`${apis_1.APP_CONSTANTS.documents.notes}?characterId=${characterId}&column=updatedAt&sort=DESC`).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data;
    }).catch((error) => new error_1.RequestError(error));
}
function getFirstNote(characterId) {
    return interceptorsCached_1.cachedAuthCall.get(`${apis_1.APP_CONSTANTS.documents.notes}?characterId=${characterId}`).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data.length > 0 ? response.data[0] : null;
    }).catch((error) => new error_1.RequestError(error));
}
function createNote(note, title, characterId) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.notes, { note, title, characterId }).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data;
    }).catch((error) => new error_1.RequestError(error));
}
function createTemplate(noteId, noteAction, characterId, conversationId) {
    return interceptorsCached_1.cachedAuthCall.post(`${apis_1.APP_CONSTANTS.documents.notesTemplate}/${noteId}/${noteAction}`, { characterId, conversationId }).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data;
    }).catch((error) => new error_1.RequestError(error));
}
function updateNote(noteId, note, title) {
    return interceptorsCached_1.cachedAuthCall.put(`${apis_1.APP_CONSTANTS.documents.notes}/${noteId}`, { note, title }).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data;
    }).catch((error) => new error_1.RequestError(error));
}
function deleteNote(noteId) {
    return interceptorsCached_1.cachedAuthCall.delete(`${apis_1.APP_CONSTANTS.documents.notes}/${noteId}`).then((response) => {
        if (!response.success) {
            return new error_1.APIError(response.error?.message);
        }
        return response.message;
    }).catch((error) => new error_1.RequestError(error));
}
function createSummary(source, language, streamingHandler, requestHandler, abortController, onAbort) {
    const SUMMARY_DETECTION_REGEX = /###\s?Summary/;
    const { files, webUrls, youtubeUrls, texts, areaOfFocus } = source;
    const payload = {
        ...DOCUMENT_PAYLOAD,
        language,
        webUrls,
        youtubeUrls,
        texts,
        areaOfFocus
    };
    return (0, streaming_1.stream)(apis_1.APP_CONSTANTS.documents.createSummaryAssistant, payload, files ?? [], streamingHandler, abortController, onAbort).then((response) => {
        if (typeof response !== 'string') {
            return new error_1.APIError(response.error?.message, { module: 'Summary', reason: 'Out of Quota' });
        }
        ;
        if (!SUMMARY_DETECTION_REGEX.test(response)) {
            return new error_1.APIError(response, { module: 'Summary' });
        }
        requestHandler(response);
    }).catch((error) => {
        if (error instanceof error_1.AuthenticationError) {
            console.error('Authentication Error');
        }
        console.error(error);
        return new error_1.RequestError(error, { module: 'Summary' });
    });
}
;
function createSummaryFromText(texts, language, streamingHandler, requestHandler, youtubeUrl, webUrl) {
    const SUMMARY_DETECTION_REGEX = /###\s?Summary/;
    const payload = {
        ...TEXT_PAYLOAD,
        language,
        youtubeUrl: youtubeUrl || "",
        webUrl: webUrl || "",
    };
    return (0, streaming_1.streamFromText)(`${application_host_1.ADD_API}${apis_1.APP_CONSTANTS.documents.createSummaryAssistant}`, texts, payload, streamingHandler).then((response) => {
        if (typeof response !== 'string') {
            return new error_1.APIError(response.error?.message, { module: 'Summary', reason: 'Out of Quota' });
        }
        ;
        if (!SUMMARY_DETECTION_REGEX.test(response)) {
            return new error_1.APIError(response, { module: 'Summary' });
        }
        requestHandler(response);
    }).catch((error) => {
        if (error instanceof error_1.AuthenticationError) {
            console.error('Authentication Error');
        }
        console.error(error);
        return new error_1.RequestError(error, { module: 'Summary' });
    });
}
;
function attachFiles(conversationId, { files, youtubeUrls, webUrls, areaOfFocus }) {
    const configs = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };
    const formData = new FormData();
    formData.append('payload', JSON.stringify({
        conversationId,
        ...(youtubeUrls && { youtubeUrls }),
        ...(webUrls && { webUrls }),
        ...(areaOfFocus && { areaOfFocus }),
    }));
    files?.forEach((file) => formData.append('file', file));
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.attachFiles, formData, configs).then((response) => {
        if (!response.success || response.error) {
            return new error_1.APIError(response.error?.message);
        }
        ;
        return response.data.createdFiles;
    }).catch((error) => {
        return new error_1.RequestError(error);
    });
}
;
function followUp(shareId) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.follow, { shareId }).then((response) => {
        if ((!response.success || response.error)
            && response.error?.message !== EXISTENT_SHARED_DOCUMENT_MESSAGE) {
            return new error_1.APIError(response.error?.message, { module: 'Summary' });
        }
        return response.data;
    }).catch((error) => {
        return new error_1.RequestError(error, {
            reason: error.response?.status === axios_1.HttpStatusCode.Unauthorized ? 'Session Out' : undefined
        });
    });
}
;
function transcriptYoutubeVideo(youtubeUrl) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.transcript, { youtubeUrl }).then((response) => {
        if ((!response.success || response.error)) {
            return new error_1.APIError(response.error?.message);
        }
        return response.data;
    }).catch((error) => {
        return new error_1.RequestError(error, {
            reason: error.response?.status === axios_1.HttpStatusCode.Unauthorized ? 'Session Out' : undefined
        });
    });
}
;
function scrapURL(webUrl) {
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.constants.scrap, { webUrl }).then((response) => {
        if (!response.headings || !response.text) {
            return new error_1.APIError('Invalid response from scraper');
        }
        return response.text;
    }).catch((error) => {
        if (error.response?.status === axios_1.HttpStatusCode.Unauthorized) {
            return new error_1.RequestError(error, { reason: 'Session Out' });
        }
        return new error_1.RequestError(error);
    });
}
function editDocumentTitle(documentJson, newTitle) {
    const updatedDocumentJson = { jsonUrl: documentJson.jsonPath, title: newTitle };
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.title, updatedDocumentJson).then((response) => {
        if (!response.success || response.error) {
            return new error_1.APIError(response.error?.message || 'Failed to edit document title');
        }
        return response;
    }).catch((error) => {
        if (error.response?.status === axios_1.HttpStatusCode.Unauthorized) {
            return new error_1.RequestError(error, { reason: 'Session Out' });
        }
        return new error_1.RequestError(error);
    });
}
function deleteDocument(fileId) {
    return interceptorsCached_1.cachedAuthCall
        .delete(`${apis_1.APP_CONSTANTS.documents.index}/${fileId}`)
        .then((response) => response.success ? response : new error_1.APIError(response.error.message))
        .catch((error) => new error_1.RequestError(error));
}
;
// Regenerate Images for Document
function regenerateImage(documentJson, newPrompt, imageModel) {
    const { character_id, imageGenerationId, conversationId, newCharacterId } = documentJson;
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };
    const formData = new FormData();
    formData.append('payload', JSON.stringify({
        modelId: 'black-forest-labs/flux-dev',
        prompt: newPrompt ?? (0, document_1.getMarkdownContent)(documentJson.summaryResponse, 'Image Prompt'),
        styleString: 'An oil painting depicting',
        aspectRatio: '16:9',
        characterId: newCharacterId,
        conversationId,
        character_id,
        imageGenerationId,
        ...imageModel
    }));
    return (interceptorsCached_1.cachedAuthCall
        .post(apis_1.APP_CONSTANTS.documents.regenerateImage, formData, config).then((response) => (response.success ? response.data : new error_1.APIError(response.error?.message))).catch((error) => new error_1.RequestError(error)));
}
;
function uploadImage(image, documentJson) {
    const { conversationId, character_id, newCharacterId, imageGenerationId } = documentJson;
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };
    const formData = new FormData();
    formData.append('file', image);
    formData.append('payload', JSON.stringify({
        modelId: 'black-forest-labs/flux-schnell',
        prompt: '',
        styleString: 'An oil painting depicting',
        aspectRatio: '16:9',
        characterId: newCharacterId,
        conversationId,
        character_id,
        imageGenerationId,
    }));
    return (interceptorsCached_1.cachedAuthCall
        .post(apis_1.APP_CONSTANTS.documents.regenerateImage, formData, config).then((response) => (response.success ? response.data : new error_1.APIError(response.error?.message))).catch((error) => new error_1.RequestError(error)));
}
;
function getDocumentImages(imageApiDto) {
    const { documentName, prompt, modelId, styleString, force, imageGenerationId, documentId } = imageApiDto;
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const payload = {
        modelId: modelId || 'black-forest-labs/flux-schnell',
        prompt: prompt || `Document: ${documentName}`,
        styleString: styleString || 'An oil painting depicting',
        aspectRatio: '16:9',
        documentId,
        imageGenerationId,
        force,
    };
    return interceptorsCached_1.cachedAuthCall
        .post(apis_1.APP_CONSTANTS.documents.regenerateImage, payload, config)
        .then((response) => response.success ? response.data : new error_1.APIError(response.error?.message))
        .catch((error) => new error_1.RequestError(error));
}
;
function generateFiveMinutesAudio(document, onStream) {
    const payload = {
        text: (0, document_1.getFiveMinuteWrapContent)('summaryResponse' in document
            ? document.summaryResponse
            : document.message),
        jsonUrl: document.jsonPath,
        type: "wrap",
        title: 'title' in document ? document.title : document.characterName,
    };
    console.log("What I can't hear you?", payload);
    const handleStream = (stream) => {
        const audioData = new Uint8Array(stream);
        // const file = new File([audioData], Math.random().toString(), { type: 'audio/mpeg' })
        const blob = new Blob([audioData], { type: 'audio/mpeg' });
        onStream(blob);
    };
    return (0, streaming_1.stream)(apis_1.APP_CONSTANTS.documents.generateAudio, payload, handleStream);
}
;
function podcastfy(document, { wordsCount, conversationStyle, hostRole, guestRole }) {
    const payload = {
        text: (0, document_1.getFiveMinuteWrapContent)(document.summaryResponse),
        custom_config: {
            word_count: wordsCount,
            conversation_style: conversationStyle,
            roles_person1: hostRole,
            roles_person2: guestRole,
            dialogue_structure: (() => {
                const intro = ['Introduction'];
                switch (hostRole) {
                    case 'thesis presenter':
                        return [...intro, 'Thesis Statement', 'Evidence & Analysis', 'Thesis Defense & Implications'];
                    case 'main summarizer':
                        return [...intro, 'Overview', 'Details', 'Recap'];
                    case 'expert analyst':
                        return [...intro, 'Context', 'Analysis', 'Insights'];
                    case 'engaging narrator':
                        return [...intro, 'Hook', 'Story', 'Reflection'];
                    case 'critical reviewer':
                        return [...intro, 'Problem', 'Critique', 'Solution'];
                    default:
                        return [...intro, 'Main Content Summary', 'Conclusion'];
                }
            })(),
            podcast_name: "SummarAIzer",
            podcast_tagline: "Where Ideas Clash and Knowledge Emerges",
            engagement_techniques: [
                "personal stories",
                "real-life examples",
                "direct listener address",
                "emotional connections",
                "reflective questions",
                "witty observations",
                "playful banter",
                "clever analogies",
                "light-hearted jokes"
            ],
            creativity: 1
        },
        jsonUrl: document.jsonPath,
    };
    return interceptorsCached_1.cachedAuthCall.post(apis_1.APP_CONSTANTS.documents.podcastfy, payload).then((response) => {
        if (!response.success || response.error) {
            return new error_1.APIError(response.error?.message);
        }
        ;
        return response.data;
    }).catch((error) => {
        return new error_1.RequestError(error);
    });
}
;
async function getUrlFromBrave(query) {
    const config = {
        method: 'get',
        url: `${apis_1.APP_CONSTANTS.constants.webSearch(query)}`,
    };
    try {
        const response = await axios_2.default.request(config);
        const results = response.data.web?.results;
        if (results && results.length >= 2) {
            return results[1].url;
        }
        return null;
    }
    catch (error) {
        if (axios_2.default.isAxiosError(error) && error.response?.status === 403) {
            console.error('Access forbidden: Check your subscription token or CORS settings.');
        }
        else {
            console.error('Request failed:', error);
        }
        return null;
    }
}
